import { MouseEvent, ReactNode, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { openPlace, PlaceSurface, usePlaceOrigin } from '../../utils/placeMotion';

interface PlaceLinkProps {
  to: string;
  surface: PlaceSurface;
  className?: string;
  ariaLabel?: string;
  draggable?: boolean;
  onClick?: (event: MouseEvent<HTMLAnchorElement>) => void;
  children: ReactNode;
}

/** A list row that grows into the place it opens, and shrinks back on return. */
export default function PlaceLink({
  to,
  surface,
  className,
  ariaLabel,
  draggable,
  onClick,
  children,
}: PlaceLinkProps) {
  const ref = useRef<HTMLAnchorElement>(null);
  const navigate = useNavigate();
  const location = useLocation();
  usePlaceOrigin(ref, surface.kind, surface.slug, surface.via);
  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    onClick?.(event);
    if (event.defaultPrevented) return;
    openPlace(event, ref.current, surface, to, navigate, location);
  };
  return (
    <Link
      ref={ref}
      to={to}
      className={className}
      aria-label={ariaLabel}
      draggable={draggable}
      onClick={handleClick}
    >
      {children}
    </Link>
  );
}
